export const cardWrapperSx = {
  mx: '1.5rem',
  my: '1rem',
  p: '1.5rem',
  userSelect: 'none',
  border: '1px solid #181D27',
  borderRadius: '0.75rem',
  '&[data-active]': {
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
};

export const cardGridSx = {
  display: 'grid',
  gridTemplateColumns: 'min(224px, 25%) 1fr min(32px, 8%)',
  columnGap: '1.5rem',
};

export const cardStickerWrapperSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
};

export const cardStickerSx = {
  width: '100%',
  objectFit: 'cover',
};

export const cardContentSx = {
  p: '0rem',
  placeContent: 'center',
};

export const cardTitleSx = {
  fontSize: 'clamp(1rem, 0.8333rem + 0.7407vw, 1.5rem);',
  fontWeight: 600,
  lineHeight: 1,
  letterSpacing: '-0.05rem',
};

export const cardBodySx = {
  fontSize: 'clamp(0.8125rem, 0.625rem + 0.8333vw, 1.375rem);',
  fontWeight: 400,
};

export const cardLinkWrapperSx = {
  display: 'inline-block',
  position: 'relative',
  fontSize: 'clamp(0.8125rem, 0.625rem + 0.8333vw, 1.375rem);',
  textAlign: 'left',
};

export const cardLinkSx = {
  display: 'inline',
  fontSize: 'inherit',
  fontWeight: 600,
  textDecoration: 'underline',
};

export const cardDismissWrapperSx = {
  display: 'flex',
  position: 'relative',
};

export const cardDismissButtonSx = {
  width: 'fit-content',
  height: 'fit-content',
  position: 'relative',
  top: '-8px',
  right: '-8px',
  padding: 'unset',
};
